import type { JSX } from 'react';
import type { PatientBanner } from '@ampshift/shared';
import { ageFromBirthDate, fullName, sexLabel } from '../surfaces/format';
import { useT, useUiLanguage } from '../i18n/useT';

export interface PatientContextState {
  activePatient: PatientBanner | null;
  activeEncounterId: string | null;
}

export function PatientIndicator({ context, onClick }: { context: PatientContextState; onClick: () => void }): JSX.Element {
  const t = useT();
  const lang = useUiLanguage();
  const p = context.activePatient;
  if (!p) {
    return (
      <button type="button" className="patient-indicator none" onClick={onClick} title={t('setPatientContext')}>
        <span className="patient-dot" aria-hidden="true" />
        <span>{t('noActivePatient')}</span>
      </button>
    );
  }
  const age = ageFromBirthDate(p.birthDate);
  return (
    <button type="button" className="patient-indicator active" onClick={onClick} title={t('setPatientContext')} data-testid="patient-indicator">
      <span className="patient-dot" aria-hidden="true" />
      <span className="patient-name">{fullName(p.name, lang === 'ar')}</span>
      <span className="patient-meta">
        {t('mrn')} {p.mrn} · {age !== undefined ? `${age}y` : ''}
        <span className="patient-meta-extra"> {p.birthDate} · {sexLabel(p.sex)}</span>
      </span>
      {p.flags.map((f) => (
        <span key={f} className="chip chip-flag">
          {f}
        </span>
      ))}
      {context.activeEncounterId ? (
        <span className="chip chip-good" title={context.activeEncounterId}>
          {t('activeEncounter')}
        </span>
      ) : null}
    </button>
  );
}
